/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import React from 'react'
import {injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {Button, Card, Grid, Input, InputLabel, Loader} from "@scuf/common";
import {assetModelHda} from "../model/Asset";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {fetchLdiNamesAndIds} from "../api/AppConfigs";
import VariantSelectors from "../admin/assets/VariantSelectors";
import engineHTF7K from '../styling/images/engine_AS907.jpg'
import engineTFE731 from '../styling/images/engine_TFE731.jpg'
import * as Fleets from '../api/Fleets'
import * as Airtime from '../api/Airtime'
import {verifyAirtimeException} from "../utils/Helpers";
import {bindActionCreators} from "redux";
import * as SecurityActions from "../security/SecurityActions";

class AirtimeAssetDetail extends React.Component {

    constructor(props) {
        super(props)

        const {profile} = this.props

        this.state = {
            readAccess: !userHasActivity(profile, [ACTIVITY_TYPES.ASSETS_WRITE]),
            assetModel: null, //assetModel(intl),
            errors: [],
            errorPaths: [],
            selectedVariants: new Map(),
            pathName: '',
            configuration: null,
            platform: null,
            ldiNamesAndIds: null,
            selectedLdiForHDR: -1,
            variants: null,
            availableConfigurationSymptoms: null,
            loading: true,
        }

        this.getErrorMessage = this.getErrorMessage.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.fetchVariants = this.fetchVariants.bind(this)
        this.fetchLdiNamesAndIds = this.fetchLdiNamesAndIds.bind(this)
    }

    fetchLdiNamesAndIds() {
        const me = this
        fetchLdiNamesAndIds().then(function (response) {
            if (response.length === 1) {
                me.setState({
                    ldiNamesAndIds: response,
                    selectedLdiForHDR: response[0].value}, me.fetchVariants)
            }
            else {
                me.setState({ldiNamesAndIds: response})
            }
        });
    }

    fulfillSelectedVariants(variants) {
        const selectedVariants = new Map();
        variants.forEach(v => {
            selectedVariants.set(v.variantType, v)
        })
        return selectedVariants;
    }

    componentDidMount() {
        this.fetchVariants();
        this.setState({assetModel: assetModelHda(this.props.intl)})
        this.fetchLdiNamesAndIds()
    }

    fetchVariants() {
        Fleets.fetchVariants(this.state.selectedLdiForHDR).then((response) => {
            const newVariants = new Map();
            response.forEach(v => {
                let varSet = newVariants.get(v.variantType);
                if (varSet == null) {
                    varSet = [];
                }
                varSet.push(v);
                newVariants.set(v.variantType, varSet);
            })
            this.setState({variants: newVariants, loading:false})
        });
    }

    getErrorMessage(fields) {
        const errs = []
        fields.forEach(field => errs.push(this.state.errorPaths.find(err => err.path === field)))

        return errs.filter(err => err !== undefined).reduce((composeMsg, err) => composeMsg ? composeMsg + "<br/>" + err.message : err.message, null)
    }

    submitForm() {
        const {intl, asset} = this.props;

        const variantArray = [...this.state.selectedVariants.values()];
        const variantIds = [];
        const ldiId = this.state.selectedLdiForHDR
        for (const i in variantArray) {
            if (variantArray.hasOwnProperty(i)) {
                variantIds.push(variantArray[i].id);
            }
        }

        const myAsset = {
            id: null,
            name: this.props.assetName,
            fleetId: 1,
            variants: variantIds,
            ldiId: ldiId,
            engineType: this.props.engineType,
            engineModel: this.props.engineModel,
            configuration: this.state.configuration,
            platform: this.state.platform,
        }

        this.state.assetModel.validate(myAsset, {abortEarly: false}).then(() => {
            this.setState({errorPaths: [], errors: []})
            Airtime.createAsset(this.props.sessionId, myAsset).then((newAsset) => {
                Airtime.reportSymptoms(this.props.sessionId).then(response => {
                    this.props.setNewFaults(response)
                }).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
                this.props.setAsset(newAsset)
            }).catch(err => {
                this.props.setLoading(false)
                if (err.errorKey === 'business.exception.ASSET_NAME_ALREADY_EXISTS') {
                    this.setState({errorPaths: [{path: 'name', message: intl.formatMessage({id: 'admin.asset.ASSET_NAME_ALREADY_EXISTS'}, {name: asset.name})}]})
                    if(err.params && err.params.length === 2 ) {
                        this.setState({existingAsset: {readAccess: err.params[0], asset: err.params[1]}});
                    }
                }
            });
        }).catch(err => {
            this.props.setLoading(false)
            if(err.inner && err.inner.map) {
                this.setState({
                    errors: err.errors, errorPaths: err.inner.map(i => {
                        return {path: i.path, message: i.errors}
                    }),
                })
            }
        })
    }

    render() {
        const {intl} = this.props

        const me = this

        return (
            <React.Fragment>
                <Card>
                    <Loader loading={this.state.loading} />
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.title'})}>
                    </Card.Header>
                    <Card.Content>
                        <Grid>
                            <Grid.Row>
                                {
                                    this.state.selectedVariants.length > 0 ?
                                        <div className="engine-picture-div">
                                            <Grid.Column width={2} sWidth={12}>
                                                <img alt="engine" className="engine-picture" src={this.state.selectedVariants[0].ldiName.includes('HTF7K') ? engineHTF7K : engineTFE731}/>
                                            </Grid.Column>
                                        </div>
                                        :
                                        null
                                }
                                <Grid.Column width={4} sWidth={12}>
                                    <div>
                                        <InputLabel label={intl.formatMessage({id: 'admin.asset.detail.name'})} />
                                        <Input fluid
                                               value={this.props.assetName}
                                               placeholder={intl.formatMessage({id: "admin.asset.detail.name"})}
                                               error={this.getErrorMessage(['name'])}
                                               disabled={true}

                                        />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>
                <Card className={"variantCard"}>
                    <Loader loading={this.state.loading} />
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.variants'})}>
                    </Card.Header>
                    <Card.Content>
                        <Grid>
                            <VariantSelectors
                                external={true}
                                assetStatus={'ACTIVE'}
                                readAccess={me.state.readAccess}
                                variants={me.state.variants}
                                selectedVariants={me.state.selectedVariants}
                                onVariantChange={(data, variantType) => {
                                    const newSelectedVariants = new Map(me.state.selectedVariants)
                                    newSelectedVariants.set(variantType, this.state.variants.get(variantType).find(function(element) {
                                        return element.id === data;
                                    }));
                                    me.setState({selectedVariants: newSelectedVariants})
                                }}
                                engineType={me.props.engineType}
                                engineModel={me.props.engineModel}
                                configuration={me.state.configuration}
                                platform={me.state.platform}
                                onEngineTypeChange={(data) => {
                                    this.props.setEngineType(data);
                                    this.setState({
                                        configuration: null,
                                        platform: null,
                                    })
                                }}
                                onEngineModelChange={(data) => {
                                    this.props.setEngineModel(data);
                                    this.setState({
                                        configuration: null,
                                        platform: null,
                                    })
                                }}
                                onConfigurationChange={(data) => {
                                    this.setState({
                                        configuration: data,
                                        platform: null,
                                    })
                                }}
                                onPlatformChange={(data, variantType) => {
                                    // HDA can have just 1 variant per Asset (there doesn''t matter on Variant types)
                                    const newSelectedVariants = new Map()
                                    newSelectedVariants.set(variantType, this.state.variants.get(variantType).find(v =>
                                        v.engineType === me.props.engineType &&
                                        v.engineModel === me.props.engineModel &&
                                        (v.configuration == null || v.configuration === me.state.configuration) &&
                                        v.platform === data
                                    ));
                                    this.setState({
                                        selectedVariants: newSelectedVariants,
                                        platform: data,
                                        selectedLdiForHDR: newSelectedVariants.get(variantType).ldiId,
                                    });
                                }}
                                getErrorMessage={(data) => this.getErrorMessage(data)}
                            />
                        </Grid>
                    </Card.Content>
                </Card>
                <div>
                    <div className="cancel-save-button-div">
                        <Button
                            type="primary"
                            content={intl.formatMessage({id: "admin.asset.detail.save"})}
                            onClick={() => {
                                this.props.setLoading(true)
                                this.submitForm()
                            }}
                            className="cancel-save-delete-button mobile-max-width-button"
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        profile: !state.security ? null : state.security.userProfile,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AirtimeAssetDetail)))
